import { Button, Result } from 'antd';
import styles from './NoTenantAssigned.module.scss';
import { BRAND_NAME } from '../../constants/branding';

interface NoTenantAssignedProps {
  onConfirm: () => void;
}

const NoTenantAssigned = ({ onConfirm }: NoTenantAssignedProps) => {
  return (
    <div className={styles.noTenant}>
      <Result
        status="warning"
        title="No Tenant Assigned"
        subTitle={
          <>
            <p>Your {BRAND_NAME} account is not associated with any tenant.</p>
            <p>Please contact your administrator to have a tenant assigned to your account.</p>
          </>
        }
        extra={
          <Button type="primary" onClick={onConfirm}>
            OK
          </Button>
        }
      />
    </div>
  );
};

export default NoTenantAssigned;
